export class PasswordPolicyRules {
	private _minLength: number
	private _minLowerLettersCount: number
	private _minUpperLettersCount: number
	private _minDigitsCount: number
	private _minSpecialSymbolsCount: number
	private _minValidityDays: number

	public get minLength(): number {
		return this._minLength
	}
	public get minLowerLettersCount(): number {
		return this._minLowerLettersCount
	}
	public get minUpperLettersCount(): number {
		return this._minUpperLettersCount
	}
	public get minDigitsCount(): number {
		return this._minDigitsCount
	}
	public get minSpecialSymbolsCount(): number {
		return this._minSpecialSymbolsCount
	}
	public get minValidityDays(): number {
		return this._minValidityDays
	}

	constructor(opObj: any) {
		this.fromJSON(opObj)
	}

	//#region IJsonSerializer Implementation

	public fromJSON(opObj: any, compressed: boolean = false): void {
		if (opObj != null) {
			this._minLength = opObj.MinLength
			this._minLowerLettersCount = opObj.MinLowerLettersCount
			this._minUpperLettersCount = opObj.MinUpperLettersCount
			this._minDigitsCount = opObj.MinDigitsCount
			this._minSpecialSymbolsCount = opObj.MinSpecialSymbolsCount
			this._minValidityDays = opObj.MinValidityDays
		}
	}

	public toJSON(compressed: boolean = false): any {
		return {
			MinLength: this._minLength,
			MinLowerLettersCount: this._minLowerLettersCount,
			MinUpperLettersCount: this._minUpperLettersCount,
			MinDigitsCount: this._minDigitsCount,
			MinSpecialSymbolsCount: this._minSpecialSymbolsCount,
			MinValidityDays: this._minValidityDays,
		}
	}
}
